import { action } from "mobx";
import api from "../../../../api";
import CoursesListStore, { CoursesGroup } from "../../../../store/coursesList.store";
import { ICourse } from "../types";

export default class FSCourseslistStore extends CoursesListStore<ICourse> {
  @action
  async getGroupsList(next?: boolean) {
    try {
      this.isLoading = next ? false : true;
      const res = await api.coursesGroups.byAuthor({
        limit: this.groupsLimit,
        page: this.page,
      });
      this.pageCount = res.paginator.pageCount;
      for (let group of res.data) {
        const courseGroup = new FSCourseGroup(group);
        await courseGroup.getCourses();
        if (courseGroup.courses.length > 0) {
          this.groups.push(courseGroup);
        }
      }

      this.isLoading = false;
    } catch (error) {
      this.error = true;
    }

  }
}

export class FSCourseGroup extends CoursesGroup<ICourse> {
  @action
  async getCourses(next?: boolean) {
    this.loading = next ? false : true;
    const resp = await api.files.courses({
      group_id: this.id,
      limit: this.PER_PAGE,
      page: this.page,
    });
    this.courses.push(...resp);
    this.hasMoreCourses = !(resp.length < this.PER_PAGE);
    this.loading = false;
  }
}



export { FSCourseslistStore };
